import { InjectionToken } from '@angular/core';
import { RouterReducerState } from '@ngrx/router-store';
import { devicesFeatureKey, DeviceState } from './devices/devices.models';
import { firmwareFeatureKey, FirmwareState } from './firmwares';
import { routerTypesFeatureKey, RouterTypesState } from './router-types/router-types.models';
import { CustomRouterState } from './router/router.serializer';
import { simCardFeatureKey, SimCardState } from './sim-cards';
import { tenantFeatureKey, TenantState } from './tenants/tenants.models';
import { userFeatureKey, UserState } from './users/users.models';

export interface AppState {
    router: RouterReducerState<CustomRouterState>;
    [userFeatureKey]: UserState;
    [tenantFeatureKey]: TenantState;
    [devicesFeatureKey]: DeviceState;
    [firmwareFeatureKey]: FirmwareState;
    [routerTypesFeatureKey]: RouterTypesState;
    [simCardFeatureKey]: SimCardState;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('Application Configuration');

export interface AppConfig {
    coreUrl: string;
    websocket_url: string;
    oidc_issuer: string;
    oidc_clientId: string;
    m2mgate_portal_url: string;
}

export const STANDARD_ROW_OPTONS = [5, 10, 25, 50, 100];
export const STANDARD_ROW_LIMIT = 10;
export const STANDARD_PAGE = 0;

// export const LiebherrToolTipOptions: TooltipOptions = {
//     placement: 'left',
//     delay: 0,
//     theme: 'light',
//     'show-delay': 0,
//     'hide-delay': 0,
// };
